export default __webpack_public_path__ + "static/media/5989-vandy.351cff68.pdf";